import React from 'react';
import { AiOutlineClose } from 'react-icons/ai'; // Close icon from Ant Design Icons
import './CustomModal.css';

const CustomModal = ({ isOpen, onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    console.log('Form submitted:', data);
    e.target.reset();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="custom-modal">
        <button className="close-icon" onClick={onClose}>
          <AiOutlineClose size={24} />
        </button>
        <div className="modal-content-wrapper">
          <div className="modal-image-section">
            <img src="/thump.jpg" alt="Contact" className="modal-image" />
          </div>
          <div className="modal-form-section">
            <h2 className="form-title">Fill out the form and talk to our counselor today</h2>
            <form onSubmit={handleSubmit}>
              <label>
                Name:
                <input type="text" name="name" required />
              </label>
              <label>
                Email:
                <input type="email" name="email" required />
              </label>
              <label>
                Phone:
                <input type="tel" name="phone" required />
              </label>
              <label>
                Message:
                <textarea name="message" rows="4" required></textarea>
              </label>
              <div className="button-group">
                <button type="button" onClick={onClose}>Cancel</button>
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
